import React, { Component, Fragment } from 'react'
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider'

import PropTypes from 'prop-types'
import moment from 'moment'

// *******************************************************
// RAIL
// *******************************************************
const railOuterStyle = {
  position: 'absolute',
  width: '100%',
  height: 40,
  transform: 'translate(0%, -50%)',
  cursor: 'pointer'
  // border: "1px solid grey"
}

const railInnerStyle = {
  position: 'absolute',
  width: '100%',
  height: 8,
  transform: 'translate(0%, -50%)',
  borderRadius: 4,
  pointerEvents: 'none',
  backgroundColor: 'rgb(155,155,155)'
}

export function SliderRail({ getRailProps }) {
  return (
    <Fragment>
      <div style={railOuterStyle} {...getRailProps()} />
      <div style={railInnerStyle} />
    </Fragment>
  )
}

SliderRail.propTypes = {
  getRailProps: PropTypes.func.isRequired
}

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
export function Handle({
  domain: [min, max],
  handle: { id, value, percent },
  disabled,
  getHandleProps
}) {
  return (
    <Fragment>
      <div
        style={{
          left: `${percent}%`,
          position: 'absolute',
          transform: 'translate(-50%, -50%)',
          WebkitTapHighlightColor: 'rgba(0,0,0,0)',
          zIndex: 5,
          width: 24,
          height: 42,
          cursor: 'pointer',
          // border: "1px solid white",
          backgroundColor: 'none'
        }}
        {...getHandleProps(id)}
      />
      <div
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        style={{
          left: `${percent}%`,
          position: 'absolute',
          transform: 'translate(-50%, -50%)',
          zIndex: 2,
          width: 20,
          height: 20,
          borderRadius: '50%',
          boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.3)',
          backgroundColor: disabled ? '#666' : '#333'
        }}
      />
    </Fragment>
  )
}

Handle.propTypes = {
  domain: PropTypes.array.isRequired,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

Handle.defaultProps = {
  disabled: false
}

// *******************************************************
// TRACK COMPONENT
// *******************************************************
export function Track({ source, target, getTrackProps, disabled }) {
  return (
    <div
      style={{
        position: 'absolute',
        transform: 'translate(0%, -50%)',
        height: 8,
        zIndex: 1,
        backgroundColor: disabled ? '#999' : '#444',
        borderRadius: 4,
        cursor: 'pointer',
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`
      }}
      {...getTrackProps()}
    />
  )
}

Track.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  target: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  getTrackProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

Track.defaultProps = {
  disabled: false
}

// *******************************************************
// TICK COMPONENT
// *******************************************************
export function Tick({ tick, count, format }) {
  return (
    <div>
      <div
        style={{
          position: 'absolute',
          marginTop: 14,
          width: 1,
          height: 5,
          backgroundColor: 'rgb(200,200,200)',
          left: `${tick.percent}%`
        }}
        
      />
      <div
        style={{
          position: 'absolute',
          marginTop: 22,
          fontSize: 10,
          textAlign: 'center',
          fontFamily: 'Arial, san-serif',
          marginLeft: `${-(100 / count) / 2}%`,
          width: `${100 / count}%`,
          left: `${tick.percent}%`,
        }}
      >
        {format(tick.value)}
      </div>
    </div>
  )
}

Tick.propTypes = {
  tick: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  count: PropTypes.number.isRequired,
  format: PropTypes.func.isRequired
}

Tick.defaultProps = {
  format: d => d
}


function range(start, end, step = 1) {
  const len = Math.floor((end - start) / step) + 1
  return Array(len).fill().map((_, idx) => start + (idx * step))
}


class GenericSlider extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    available: PropTypes.array.isRequired,
    selected: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props)

    const available = this.props.available

    let domain, disabled, selected, ticks

    // If only one option
    if (available.length === 1) {
      domain = [available[0] - 1, available[0] + 1]
      disabled = true
      ticks = [available[0] - 1, available[0], available[0] + 1]
      selected = [available[0], available[0]]
    } else {
      domain = [available[0], available.slice(-1)[0]]
      disabled = false
      ticks = available

      // Is the previously selected range compatible?
      const [selFrom, selTo] = this.props.selected
      const [domFrom, domTo] = domain

      let from, to
      if (selFrom >= domFrom && selFrom <= domTo) {
        from = selFrom
      } else {
        from = domFrom
      }

      if (selTo >= domFrom && selTo <= domTo) {
        to = selTo
      } else {
        to = domTo
      }

      selected = [from, to]
    }

    this.state = {
      disabled: disabled,
      domain: domain,
      selected: selected,
      updated: selected,
      ticks: ticks
    }
  }

  onChange = (values) => {
    this.setState({ selected: values })
    this.props.onChange(values)
  }

  componentDidMount() {
    if (this.props.selected.length == 0) {
      this.props.onChange(this.state.selected)
    }
    // if (this.state.disabled) {
    //   this.props.onChange(this.state.selected)
    // }
  }


  render() {

    const sliderStyle = {
      position: 'relative',
      width: '100%'
    }

    return(
      <div style={{ margin: '0%', height: 50, width: '100%' }}>
        <Slider
          disabled={this.state.disabled}
          mode={this.props.mode || 1}
          step={1}
          domain={this.state.domain}
          rootStyle={sliderStyle}
          onChange={this.onChange}
          values={this.state.selected}
        >
          <Rail
            
          >
            {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map(handle => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    domain={this.state.domain}
                    getHandleProps={getHandleProps}
                    disabled={this.state.disabled}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}                    
                  />
                ))}
              </div>
            )}
          </Tracks>
          <Ticks values={this.state.ticks} >
            {({ ticks }) => (
              <div className="slider-ticks">
                {ticks.map(tick => (
                  <Tick key={tick.id} tick={tick} count={ticks.length} format={this.props.tickFormatter} />
                ))}
              </div>
            )}
          </Ticks>
        </Slider>
      </div>
    )
  }
}

export default class DateSlider extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    minDt: PropTypes.object.isRequired,
    maxDt: PropTypes.object.isRequired,
  }
  
  constructor(props) {
    super(props)

    this.state = {
      minDt: this.props.minDt,
      maxDt: this.props.maxDt,
      years: [],
      months: [],
      days: [],
      hours: [],
    }
  }

  onYearChange = (values) => {
    this.setState({ years: values })
  }

  onMonthChange = (values) => {
    this.setState({ months: values })
  }

  onDayChange = (values) => {
    this.setState({ days: values })
  }

  onHourChange = (values) => {
    this.setState({ hours: values })
  }

  componentDidUpdate(_prevProps, prevState) {
    
    if (this.state != prevState) {
      
      let m0, m1, g
      // If multiple years
      if (this.state.years[0] != this.state.years[1]) {
        m0 = moment(`${this.state.years[0]}`, 'YYYY').startOf('year')
        m1 = moment(`${this.state.years[1]}`, 'YYYY').endOf('year')
        g = 'year'
        
      // If mulitple months
      } else if (this.state.months[0] != this.state.months[1]) {
        m0 = moment(`${this.state.years[0]}-${this.state.months[0]}`, 'YYYY-MM').startOf('month')
        m1 = moment(`${this.state.years[0]}-${this.state.months[1]}`, 'YYYY-MM').endOf('month')
        g = 'month'

      // If multiple days
      } else if (this.state.days[0] != this.state.days[1]) {  
        m0 = moment(`${this.state.years[0]}-${this.state.months[0]}-${this.state.days[0]}`, 'YYYY-MM-DD').startOf('day')
        m1 = moment(`${this.state.years[0]}-${this.state.months[0]}-${this.state.days[1]}`, 'YYYY-MM-DD').endOf('day')
        g = 'day'

      // If multiple hours
      } else if (this.state.hours[0] != this.state.hours[1]) {
        m0 = moment(`${this.state.years[0]}-${this.state.months[0]}-${this.state.days[0]} ${this.state.hours[0]}`, 'YYYY-MM-DD HH').startOf('hour')
        m1 = moment(`${this.state.years[0]}-${this.state.months[0]}-${this.state.days[0]} ${this.state.hours[1]}`, 'YYYY-MM-DD HH').endOf('hour')
        g = 'hour'
      }

      this.props.onChange([m0, m1], g)
      // this.props.onChange([m0.format("YYYY-MM-DD HH:mm:ss"), m1.format("YYYY-MM-DD HH:mm:ss")], g)
    }
  }

  formatTick = (mom) => {
    return moment(mom).format('DD MMM')
  }

  render() {

    const yearsSlider = () => {
      const years = range(this.state.minDt.year(), this.state.maxDt.year())

      return (
        <>
          <p className="mb-3 has-text-centered">Ano</p>
          <GenericSlider
            available={years}
            selected={this.state.years}
            onChange={this.onYearChange}
          />
        </>
      )
    }

    const monthSlider = () => {
      if (!this.state.years.length || this.state.years[0] != this.state.years[1]) {
        return <></>
      }

      const year = this.state.years[0]

      let months
      if (year == this.state.minDt.year()) {
        months = range(this.state.minDt.month() + 1, 12)
      } else if (year == this.state.maxDt.year()) {
        months = range(1, this.state.maxDt.month() + 1)
      } else {
        months = range(1, 12)
      }

      return (
        <>
          <p className="mb-3 has-text-centered">Mês</p>
          <GenericSlider
            available={months}
            selected={this.state.months}
            onChange={this.onMonthChange}
          />
        </>
      )
    }

    const daySlider = () => {

      if (!this.state.months.length || this.state.months[0] != this.state.months[1]) {
        return <></>
      }

      const year = this.state.years[0]
      const month = this.state.months[0]
      const daysInMonth = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()

      let days  
      if (year == this.state.minDt.year() && month == this.state.minDt.month() + 1) {
        days = range(this.state.minDt.date(), daysInMonth)
      } else if (year == this.state.maxDt.year() && month == this.state.maxDt.month() + 1) {
        days = range(1, this.state.maxDt.date())
      } else {
        days = range(1, daysInMonth)
      }

      return (
        <>
          <p className="mb-3 has-text-centered">Dia</p>
          <GenericSlider
            available={days}
            selected={this.state.days}
            onChange={this.onDayChange}
          />
        </>
      )
    }

    const hourSlider = () => {

      if (!this.state.days.length || this.state.days[0] != this.state.days[1]) {
        return <></>
      }

      const year = this.state.years[0]
      const month = this.state.months[0]
      const day = this.state.days[0]

      let hours  
      if (year == this.state.minDt.year() && month == this.state.minDt.month() + 1  && day == this.state.minDt.date()) {
        hours = range(this.state.minDt.hour(), 23)
      } else if (year == this.state.maxDt.year() && month == this.state.maxDt.month() + 1 && day == this.state.maxDt.date()) {
        hours = range(0, this.state.maxDt.hour())
      } else {
        hours = range(0, 23)
      }

      return (
        <>
          <p className="mb-3 has-text-centered">Hora</p>
          <GenericSlider
            available={hours}
            mode={2}
            selected={this.state.hours}
            onChange={this.onHourChange}
          />
        </>
      )
    }

    return (
      <>
        {yearsSlider()}
        {monthSlider()}
        {daySlider()}
        {hourSlider()}
      </>

    )
  }
}
